<template>
  <section class="contact-banner">
    <div class="banner-container">
      <img src="../assets/banner-contato.jpg" alt="Contato Banner" class="banner-image" />
      <div class="banner-content">
        <p>Estamos aqui para ajudar você a transformar o seu negócio através da tecnologia.</p>
        <p>
          Entre em contato com a <strong>CATENA SYSTEM</strong> e descubra como nossas soluções tecnológicas podem impulsionar o seu negócio. Preencha o formulário abaixo ou utilize um dos nossos canais de atendimento. Nossa equipe está pronta para responder suas dúvidas e apresentar as melhores
          soluções para o seu projeto.
        </p>
      </div>
    </div>
  </section>

  <section class="contact-form-section">
    <h2>Estamos prontos para transformar suas ideias em soluções tecnológicas eficientes. Entre em contato agora!</h2>

    <FormContatoVue :isDarkMode="true" />
  </section>

  <!-- <section class="contact-info">
    <p>
      Fale diretamente com um de nossos especialistas.<br />
      Entre em contato pelos nossos canais abaixo:
    </p>
    <p>Telefone: 31 98934-4230</p>
    <p>Endereço: Rua Cordisburgo, 23 - Santa Inês - Belo Horizonte/MG 31999-999</p>
  </section> -->
</template>

<script>
import FormContatoVue from "@/components/FormContato.vue";

export default {
  components: {
    FormContatoVue,
  },
};
</script>

<style scoped>
.contact-banner {
  position: relative;
  width: 100%;
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.banner-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-content {
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translateY(-50%);
  background-color: rgba(39, 72, 98, 0.85);
  color: white;
  padding: 20px;
  max-width: 450px;
  border-radius: 10px;
  font-size: 1em;
}

.contact-form-section {
  background-color: #274862;
  padding: 50px;
  text-align: center;
  color: white;
}

.contact-form-section h2 {
  margin: 0px 250px 50px 250px;
  font-size: 1.8em;
}

.contact-info {
  background-color: white;
  text-align: center;
  padding: 30px;
  font-size: 1em;
  color: #274862;
}

.contact-info p {
  margin-bottom: 10px;
}
</style>
